module.exports = __webpack_public_path__ + "img/携程.7e64f12d.jpg";